<template>
  <div>
    <!-- @login="loginDate" -->

    <Head></Head>
    <navigationbar cid="0"></navigationbar>
    <div class="bg-color-eae flex flex-direction align-center">
      <div class="bg-white flex justify-center">

        <div class="width flex shadow">
          <div class="flex flex-direction">
            <div @click="checkIndex(0)"
                 class="left flex flex-direction justify-center align-center cursor-pointer"
                 :class="index == 0 ? 'activity' : ''">
              <img class="img1"
                   v-if="index == 0"
                   src="../../assets/pserson/pseron-check.png"
                   alt="" />
              <img class="img1"
                   v-else
                   src="../../assets/pserson/person.png"
                   alt="" />
              我的学习
            </div>
            <div @click="checkIndex(1)"
                 class="left flex flex-direction justify-center align-center cursor-pointer"
                 :class="index == 1 ? 'activity' : ''">
              <img class="img2"
                   v-if="index == 1"
                   src="../../assets/pserson/share-check.png"
                   alt="" />
              <img class="img2"
                   v-else
                   src="../../assets/pserson/share.png"
                   alt="" />
              我的分享
            </div>
            <div @click="checkIndex(2)"
                 class="left flex flex-direction justify-center align-center cursor-pointer"
                 :class="index == 2 ? 'activity' : ''">
              <img class="img3"
                   v-if="index == 2"
                   src="../../assets/pserson/set-check.png"
                   alt="" />
              <img class="img3"
                   v-else
                   src="../../assets/pserson/set.png"
                   alt="" />
              我的设置
            </div>

          </div>

          <div v-if="index == 1"
               class="flex-sub bg-color-ff flex flex-direction justify-center">

            <div class="flex justify-between align-center top">
              <p class="first activity font-size-24 font-color-ff">分享的课程</p>
              <div class="flex font-size-22 align-center">
                <div v-if="isEdit"
                     class="annimation flex">
                  <p @click="allcheck"
                     class="p-pad cursor-pointer flex flex-center">
                    <img class="edit"
                         src="../../assets/pserson/all.png" />
                    全选
                  </p>
                  <p @click="deleteItem()"
                     class="p-pad cursor-pointer flex flex-center">
                    <img class="edit"
                         src="../../assets/pserson/delete.png" />
                    删除
                  </p>
                  <p @click="eidtClick(false)"
                     class="p-pad cursor-pointer flex flex-center">
                    <img class="edit"
                         src="../../assets/pserson/cansle.png" />
                    取消
                  </p>
                </div>
                <p v-if="length>0&&!isEdit"
                   @click="eidtClick(true)"
                   class="p-pad cursor-pointer flex flex-center">
                  <img class="edit"
                       src="../../assets/pserson/edit.png" />
                  编辑
                </p>
              </div>
            </div>
            <div class="right">
              <courseItem v-for="(item, index) in dataList"
                          :key="index"
                          :item="item"
                          :isEdit='isEdit'
                          style="margin-top: 0.38rem; margin-left: 0.44rem">
              </courseItem>

              <div v-if="length == 0"
                   class="empty font-color-94 flex flex-direction justify-center align-center font-size-36">
                <img style="width: 3.66rem; heigh: 3.32rem"
                     src="../../assets/pserson/empty.png" />
                空空如也，你还没有看过任何课程~
                <p @click="toLook"
                   class="bg-color-ffcb font-size-30 font-color-ff cursor-pointer">
                  去课程频道看看
                  <img src="../../assets/pserson/right-arrw.png" />
                </p>
              </div>
            </div>
            <div style="margin: 0.5rem auto;">

              <paginate v-if="totalPage>0"
                        :pages="totalPage"
                        @jump="jumpPage"
                        :groups="totalPage>5?5:totalPage"></paginate>
            </div>

          </div>

          <div v-if="index == 0"
               class="flex-sub bg-color-ff flex flex-direction justify-center">
            <div class="flex justify-between align-center top">
              <div class="flex">
                <p @click="setMineCheck('like')"
                   :class="{ activity: mineCheck == 'like' }"
                   class="first font-size-24 font-color-ff">
                  喜欢
                </p>
                <p @click="setMineCheck('play')"
                   style="margin-left: 0.2rem"
                   :class="{ activity: mineCheck == 'play' }"
                   class="first font-size-24 font-color-ff">
                  正在学
                </p>
              </div>

              <div class="flex font-size-22 align-center">
                <div v-if="isEdit"
                     class="annimation flex">
                  <p @click="allcheck"
                     class="p-pad cursor-pointer flex flex-center">
                    <img class="edit"
                         src="../../assets/pserson/all.png" />
                    全选
                  </p>
                  <p @click="deleteItem()"
                     class="p-pad cursor-pointer flex flex-center">
                    <img class="edit"
                         src="../../assets/pserson/delete.png" />
                    删除
                  </p>
                  <p @click="eidtClick(false)"
                     class="p-pad cursor-pointer flex flex-center">
                    <img class="edit"
                         src="../../assets/pserson/cansle.png" />
                    取消
                  </p>
                </div>
                <p v-if="length>0&&!isEdit"
                   @click="eidtClick(true)"
                   class="p-pad cursor-pointer flex flex-center">
                  <img class="edit"
                       src="../../assets/pserson/edit.png" />
                  编辑
                </p>
              </div>
            </div>
            <div class="right">
              <courseItem v-for="(item, index) in dataList"
                          :key="index"
                          :item="item"
                          :isEdit='isEdit'
                          style="margin-top: 0.38rem; margin-left: 0.44rem">
              </courseItem>
              <div v-if="length == 0"
                   class="empty font-color-94 flex flex-direction justify-center align-center font-size-36">
                <img style="width: 3.66rem; paddingBottom: 0.2rem"
                     src="../../assets/pserson/empty.png" />
                空空如也，你还没有看过任何课程~
                <p @click="toLook"
                   class="bg-color-ffcb font-size-30 font-color-ff cursor-pointer">
                  去课程频道看看
                  <img src="../../assets/pserson/right-arrw.png" />
                </p>
              </div>

            </div>
            <div style="margin: 0.5rem auto">

              <paginate v-if="totalPage>0"
                        :pages="totalPage"
                        @jump="jumpPage"
                        :groups="totalPage>5?5:totalPage"></paginate>
            </div>
          </div>
          <div v-if="index == 2"
               class="flex-sub bg-color-ff">
            <div class="flex align-center top">
              <p @click="mineClick('information')"
                 :class="{ activity: mineset == 'information' }"
                 class="first font-size-24 font-color-ff">
                用户信息
              </p>
              <p @click="mineClick('password')"
                 style="margin-left: 0.2rem"
                 :class="{ activity: mineset == 'password' }"
                 class="first font-size-24 font-color-ff">
                修改密码
              </p>
            </div>
            <div v-if="mineset == 'password'"
                 class="set flex flex-direction align-center flex-sub">
              <div class="font-color-33 font-size-26"
                   style="margin-top: 0.33rem">

                旧 密 码
                <input @input="inputOldPw"
                       type="password"
                       placeholder="请输入密码"
                       style="margin-left: 0.2rem" />
              </div>
              <div class="font-color-33 font-size-26"
                   style="margin-top: 0.33rem">
                新 密 码
                <input @input="inputNewPw"
                       type="password"
                       placeholder="请输入新密码"
                       style="margin-left: 0.2rem" />
              </div>
              <div class="font-color-33 font-size-26"
                   style="margin-top: 0.33rem">
                确认密码
                <input @input="inputSurePw"
                       type="password"
                       placeholder="请确认密码"
                       style="margin-left: 0.2rem" />
              </div>
              <p @click="savePw"
                 class="p1 cursor-pointer font-size-32 font-color-ff font-bold"
                 style="margin-bottom: 1.37rem">
                保存
              </p>
            </div>
            <div v-if="mineset == 'information'&&userInfor!=null"
                 style="margin-left: 0.4rem"
                 class="set flex flex-direction font-color-33 font-size-26">
              真实姓名
              <div class="tipdiv">
                <input type="text"
                       @input="inputRealName"
                       :value="realName"
                       placeholder="请输入真实姓名" />
                <div class="tip font-size-20 font-color-22 font-color-bf">
                  <img src="../../assets/pserson/tip.png" />

                  <p style="margin-left:0.1rem;">请输入真实姓名</p>
                </div>
              </div>

              手机号码
              <input type="text"
                     :value="userBase.PhoneNumber"
                     readonly
                     style="margin-top: 0.18rem; margin-bottom: 0.4rem" />

              宝宝出生日期
              <div class="tipdiv">

                <input type="date"
                       @input="inputBirthday"
                       :value="birthday"
                       placeholder="0001-01-01">
                <div class="tip font-size-20 font-color-22 font-color-bf">
                  <img src="../../assets/pserson/tip.png" />

                  <p style="margin-left:0.1rem;">请注意日期格式(选填)</p>
                </div>
              </div>
              宝宝性别
              <!-- onchange='clickSex()' -->
              <div class="tipdiv">
                <div class="select">
                  <select id="UserSex"
                          @change="clickSex()"
                          name="UserSex">
                    <option value="-1"
                            :selected='userSex==-1?true:false'>请选择</option>
                    <option value="0"
                            :selected='userSex==0?true:false'>女宝宝</option>
                    <option value="1"
                            :selected='userSex==1?true:false'>男宝宝</option>
                  </select>
                </div>
              </div>
              通讯地址

              <div class="tipdiv">
                <input type="text"
                       @input="inputAdress"
                       :value="address"
                       placeholder="请输入通讯地址" />
                <div class="tip font-size-20 font-color-22 font-color-bf">
                  <img src="../../assets/pserson/tip.png" />

                  <p style="margin-left:0.1rem;">用于邮寄奖品</p>

                </div>
              </div>

              最喜爱看的类型
              <div class="tipdiv">
                <!-- onchange='clickUserLikeCatalog()' -->
                <div class="select">
                  <select id="UserLikeCatalog"
                          @change="clickUserLikeCatalog()"
                          name="UserLikeCatalog">
                    <option value="0"
                            :selected='userLikeCatalog==0?true:false'>请选择</option>
                    <option value="1"
                            :selected='userLikeCatalog==1?true:false'>绘本</option>
                    <option value="2"
                            :selected='userLikeCatalog==2?true:false'>电子书</option>
                    <option value="3"
                            :selected='userLikeCatalog==3?true:false'>画报</option>
                    <option value="4"
                            :selected='userLikeCatalog==4?true:false'>Flash动画</option>
                  </select>
                </div>
                <div class="tip_xl font-size-20 font-color-22 font-color-bf">
                  <img src="../../assets/pserson/tip.png" />
                  <p style="margin-left:0.1rem;">您的选项，将作为本平台资源建设的宝贵意见</p>

                </div>
              </div>

              最喜爱看的内容
              <div class="tipdiv">
                <!-- onchange='clickUserLikeContent()' -->
                <div class="select">
                  <select id="UserLikeContent"
                          @change="clickUserLikeContent()"
                          name="UserLikeContent">
                    <option value="0"
                            :selected='userLikeContent==0?true:false'>请选择</option>
                    <option value="1"
                            :selected='userLikeContent==1?true:false'>童话、寓言等故事类</option>
                    <option value="2"
                            :selected='userLikeContent==2?true:false'>国学历史类</option>
                    <option value="3"
                            :selected='userLikeContent==3?true:false'>科技科普类</option>
                    <option value="4"
                            :selected='userLikeContent==4?true:false'>生活百科类</option>
                    <option value="5"
                            :selected='userLikeContent==5?true:false'>艺术熏陶类</option>
                    <option value="6"
                            :selected='userLikeContent==6?true:false'>学科知识类</option>
                  </select>
                </div>
                <div class="tip_xl font-size-20 font-color-22 font-color-bf">
                  <img src="../../assets/pserson/tip.png" />
                  <p style="margin-left:0.1rem;">您的选项，将作为本平台资源建设的宝贵意见</p>

                </div>
              </div>

              <p @click="savePerson"
                 class="p1 cursor-pointer font-size-32 font-color-ff font-bold"
                 style="margin-top: 0.64rem; margin-bottom: 1.37rem">
                保存
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="seconddiv"></div>
    </div>
  </div>
</template>

<script>
import common from '../../utils/common'

export default {
  data () {
    return {


      birthday: "0001-01-01",
      userSex: -1,
      userLikeContent: 0,
      userLikeCatalog: 0,
      realName: '',
      address: '',


      totalPage: 0,
      pageIndex: 1,

      index: 0,
      userBase: common.userBase,
      userInfor: null,
      isEdit: false,

      mineCheck: "like", //like-点赞 share-分享 play-学习
      mineset: "information",

      dataList: [],
      newpw: '',
      oldpw: '',
      surepw: '',

    };
  },
  computed: {
    length () {
      return this.dataList.length;
    },

  },
  created () {
    this.loginDate();

  },
  watch: {
    dataList () {
      if (this.dataList.length == 0) {
        this.isEdit = false;
      }
    }
  },
  methods: {
    toLook () {
      for (var i = 0; i < common.cate_fr.length; i ++) {
        if (common.cate_fr[i].CatalogType==1) {
           this.$router.push({
              name: "list",
              query: { p: common.cate_fr[i].Id },
            });
          break
        }
      }
    },
    inputAdress (event) {

      this.adress = event.target.value;
    },
    inputRealName (event) {

      this.realName = event.target.value;
    },
    inputBirthday (event) {

      this.birthday = event.target.value;
    },
    clickSex () {
      var myselect = document.getElementById("UserSex");
      this.userSex = myselect.options[myselect.selectedIndex].value;

    },
    clickUserLikeContent () {

      var myselect = document.getElementById("UserLikeContent");
      this.userLikeContent = myselect.options[myselect.selectedIndex].value;
    },
    clickUserLikeCatalog () {
      var myselect = document.getElementById("UserLikeCatalog");
      this.userLikeCatalog = myselect.options[myselect.selectedIndex].value;
    },
    loginDate () {

      if (this.userBase == null) {
        var http = "https://login.bjadks.com/Auth/Login?bodyClass=kid&redirectUrl=" + encodeURI(window.location.href);
        window.open(http, '_self');
      } else {
        if (this.userBase.UserType == 0) {
          var http = "https://login.bjadks.com/Auth/Login?bodyClass=kid&redirectUrl=" + encodeURI(window.location.href);
          window.open(http, '_self');
        } else {

          this.getVideoList()
        }
      }
    },
    //select 设置选中
    // setcheckItem (selectId, checkValue) {

    //   var selectdd = document.getElementById(selectId)
    //   for (var i = 0; i < selectdd.options.length; i++) {
    //     if (selectdd.options[i].value == checkValue) {
    //       selectdd.options[i].selected = true;
    //       break;
    //     }
    //   }
    // },

    //保存个人信息
    savePerson () {
      this.postRequest('api/v1/UserCenter/UpdateUserInfo', {
        UserId: this.userBase.UserId,
        RealName: this.realName,
        UserPhone: this.userBase.PhoneNumber,
        Birthday: this.birthday,
        Gender: this.userSex,
        Address: this.adress,
        LikeCatalog: this.userLikeCatalog,
        LikeContent: this.userLikeContent,

      }).then(data => {
        console.log(data)
        if (data.IsSuccess) {
          this.$toast.success(data.Message)
          this.getPersonInfor();
        }
      })
      // var userSexselect = document.getElementById("UserSex")
      // console.log('=========+++' + userSexselect);
      // var usersex = userSexselect.options[userSexselect.selectedIndex].value;
      // var userLikeContent = document.getElementById("UserLikeContent").selectedIndex;
      // var userLikeCatalog = document.getElementById("UserLikeCatalog").selectedIndex;
      // console.log(usersex + "------" + userLikeContent + "--------" + userLikeCatalog);

    },
    // 获取个人信息
    getPersonInfor () {
      var that = this;
      if (this.userInfor != null) {
        return
      }
      this.getRequest('api/v1/UserCenter/GetUserInfo', {
        UserId: this.userBase.UserId,


      }).then(data => {
        console.log(data)
        if (data.IsSuccess) {
          that.userInfor = data.Data;
          this.userSex = data.Data.Gender
          this.userLikeCatalog = data.Data.LikeCatalog
          this.userLikeContent = data.Data.LikeContent
          this.realName = data.Data.RealName;
          this.birthday = data.Data.BirthdayStr
          this.address = data.Data.Address;
        }
      })
    },
    //
    jumpPage (page) {
      this.pageIndex = page
      this.getVideoList();
    },
    setMineCheck (itemKey) {
      if (this.mineCheck != itemKey) {
        this.mineCheck = itemKey;
        this.getVideoList();
      }
    },


    allcheck () {
      for (var i = 0; i < this.dataList.length; i++) {
        this.$set(this.dataList[i], "check", true);
      }
    },
    //获取视频列表
    getVideoList () {
      this.getRequest('api/v1/UserCenter/VideoList', {
        UserId: this.userBase.UserId,
        ComId: this.userBase.ComId,
        Type: this.mineCheck,
        PageIndex: this.pageIndex,
        PageSize: 15

      }).then(data => {
        console.log(data)
        if (data.IsSuccess) {
          this.totalPage = data.Data.TotalPage
          this.dataList = data.Data.DataList
        }
      })
    },
    // 修改密码
    savePw () {
      if (this.oldpw.length == 0) {
        this.$toast.info('请输入密码')
        return
      }
      if (this.newpw.length == 0) {
        this.$toast.info('请输入新密码')
        return
      }
      if (this.surepw.length == 0) {
        this.$toast.info('请确认密码')
        return
      }

      this.postRequest('api/v1/UserCenter/UpdatePwd', {
        UserId: this.userBase.UserId,
        OldPassword: this.oldpw,
        NewPassword: this.newpw,
        ConfirmPassword: this.surepw
      }).then(data => {

        if (data.IsSuccess) {
          this.$toast.success(data.Message)
        }
      })
    },
    inputSurePw (event) {
      this.surepw = event.target.value
      console.log(event.target.value)
    },
    inputNewPw (event) {
      this.newpw = event.target.value
    },
    inputOldPw (event) {
      this.oldpw = event.target.value
    },
    deleteItem () {
      var list = [];
      for (var i = this.dataList.length - 1; i >= 0; i--) {
        if (this.dataList[i].check) {
          list.push(this.dataList[i].Id)
        }
      }

      this.postRequest('api/v1/UserOperate/DeleteOperates', {
        UserId: this.userBase.UserId,
        DelType: this.mineCheck,
        Ids: list,
      }).then(data => {
        console.log(data);
        if (data.IsSuccess) {
          this.pageIndex = 1;
          this.getVideoList();
        }
      })

    },
    mineClick (minclick) {
      if (this.mineset != minclick) this.mineset = minclick;
    },
    checkIndex (index) {
      if (this.index != index) {
        this.index = index;
        if (index == 1) {
          this.mineCheck = "share";
          this.pageIndex = 1;
          this.getVideoList();
        } else if (index == 0) {
          this.mineCheck = 'like'
          this.pageIndex = 1;
          this.getVideoList();
        } else {
          this.getPersonInfor();
        }
      }
    },
    eidtClick (isEidte) {

      // this.$toast.info('传递字符串作为通知的内容')
      if (this.dataList.length == 0) {
        return;
      }
      this.isEdit = isEidte;
      if (isEidte == false) {
        for (var i = 0; i < this.dataList.length; i++) {
          this.$set(this.dataList[i], "check", false);
        }
      }
    },
  },
};
</script>

<style scoped>
li:hover {
  background: red;
  color: orange;
}

.shadow {
  z-index: 3;
  border-radius: 0.16rem;
  background: #f2f2f2;
  overflow: hidden;
  margin: 0.35rem 0.15rem 0.2rem;
  box-shadow: 0px 0px 0.22rem 0.05rem rgba(215, 188, 219, 0.35);
}

.left {
  width: 2.31rem;
  height: 1.82rem;
  color: #8a8a8a;
  font-size: 0.24rem;
}

.left .img1 {
  width: 0.45rem;
  height: 0.54rem;

  margin-bottom: 0.16rem;
}

.left .img2 {
  width: 0.54rem;
  height: 0.54rem;
  margin-bottom: 0.16rem;
}

.left .img3 {
  width: 0.56rem;
  margin-bottom: 0.16rem;
  height: 0.57rem;
}
input[type="date"]::-webkit-inner-spin-button {
  visibility: hidden;
}
input[type="date"]::-webkit-clear-button {
  display: none;
}
input[type="date"]::-webkit-datetime-edit-text {
  color: #333;
  padding: 0 0.5em;
}

.right {
  display: flex;
  flex-grow: 1;
  flex-wrap: wrap;
  align-content: flex-start;
  padding-left: 0.3rem;
}

.set {
  flex-grow: 1;
  overflow: hidden;
  margin-top: 1rem;
}

.set input {
  width: 5.47rem;
  height: 0.64rem;
  background: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 0.1rem;
  color: #222222;
  font-size: 0.23rem;
  padding: 0 0.24rem;
  box-sizing: border-box;
  outline-style: none;
}

.set .tipdiv {
  display: flex;
  flex-direction: row;
  margin-top: 0.18rem;
  margin-bottom: 0.4rem;

  box-sizing: border-box;
}

.tip {
  margin-left: 0.2rem;
  margin-right: 0.2rem;
  background-image: url("../../assets/pserson/input.png");
  background-size: 100% 0.64rem;
  height: 0.64rem;
  max-width: 5rem;
  min-width: 2.3rem;
  display: flex;
  padding: 0 0.3rem;
  align-items: center;
  background-repeat: no-repeat;
}

.tip_xl {
  margin-left: 0.2rem;
  margin-right: 0.2rem;
  background-image: url("../../assets/pserson/input-xl.png");
  background-size: 100% 0.64rem;
  height: 0.64rem;
  max-width: 5rem;
  min-width: 2.3rem;
  display: flex;
  padding: 0 0.3rem;
  align-items: center;
  background-repeat: no-repeat;
}

.tip_xl img {
  width: 0.29rem;
  height: 0.3rem;
}

.tip img {
  width: 0.29rem;
  height: 0.3rem;
}

.yzm {
  position: absolute;
  right: 0;
  top: 0;
  width: 1.57rem;
  height: 0.64rem;
  background: #23cebc;
  border: 1px solid #23cebc;
  border-radius: 0 0.1rem 0.1rem 0;
  line-height: 0.64rem;
}

.set input ::placeholder {
  color: #c4c4c4;
  font-size: 0.23rem;
}

.set .p1 {
  margin-top: 1.64rem;
  width: 5.46rem;
  height: 0.71rem;
  background: #ffcb05;
  border-radius: 0.36rem;
  line-height: 0.71rem;
  text-align: center;
  animation: box-shadow 0.3m;
}

.set .p1:hover {
  animation: box-shadow 0.3m;
  box-shadow: 0px 0px 0.2rem 0px rgba(188, 188, 188, 0.35);
}

.seconddiv {
  height: 2.45rem;
  margin-top: -2rem;
  bottom: 0;
  left: 0;
  background: #eaecde url("../../assets/pserson/bg_bottom.png") no-repeat center
    bottom;
  width: 100%;
  background-size: 100% auto;
}
.set input :focus {
  width: 5.47rem;
  height: 0.64rem;
  background: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 0.1rem;
}

.activity {
  border-left: #23cebc solid 0.02rem;
  background: #ffffff;
  color: #23cebc;
  font-size: 0.24rem;
}

.top {
  height: 0.92rem;
  padding: 0.38rem 0.6rem 0;
}

.top .first {
  height: 0.57rem;
  border-radius: 0.3rem;
  line-height: 0.57rem;
  padding: 0 0.3rem;
  min-width: 1.47rem;
  text-align: center;
  background: #f2f2f2;
  color: #6f6f6f;
  cursor: pointer;
  animation: box-shadow 0.3m;
}

.top .first :hover {
  animation: box-shadow 0.3m;
  box-shadow: 0px 0px 0.2rem 0px rgba(188, 188, 188, 0.35);
}

.top .activity {
  background: #23cebc;
  color: #ffffff;
}

.edit {
  width: 0.24rem;
  height: 0.24rem;
}

.annimation {
  transition: all 1m;
}

.p-pad {
  padding-left: 0.5rem;
}

.p-pad:hover {
  color: #0cb4a2;
}

.p-pad img {
  margin-right: 0.08rem;
}

.empty {
  width: 100%;
  margin-top: 0.6rem;
  margin-bottom: 0.44rem;
}

.empty p {
  margin-top: 0.4rem;
  width: 3.27rem;
  height: 0.67rem;
  background: #ffcb05;
  border-radius: 0.34rem;
  text-align: center;
  line-height: 0.67rem;
}

.empty p img {
  width: 0.13rem;
  height: 0.22rem;
}

.select {
  width: 5.47rem;
  height: 0.64rem;

  overflow: hidden;

  position: relative;
  display: block;
}

select {
  width: 5.47rem;
  height: 0.64rem;
  border-radius: 0.1rem;
  padding: 0 0.24rem;
  border: 1px solid #dddddd;
  background-color: #ffffff;
  color: #222222;
  outline: none;
  font-size: 0.23rem;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline-style: none;
}
.select:after {
  content: url(../../assets/pserson/arraw.png);
  position: absolute;
  right: 0.22rem;
  top: 0.1rem;
  z-index: 1;
  text-align: center;
  width: 0.24rem;
  height: 0.13rem;
  pointer-events: none;
  box-sizing: border-box;
}
select:hover {
  border: 1px solid #f40;
}

select::-ms-expand {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/view/user/pserson.vue